import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  active: {
    color: '#005aa3',
    cursor: 'pointer',
    transition: 'opacity 0.5s',
    marginLeft: '8px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0.46px',
  },

  disabled: {
    color: theme.palette.text.disabled,
    cursor: 'default',
    pointerEvents: 'none',
    transition: 'opacity 0.5s',
    marginLeft: '8px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0.46px',
    '&:hover': {
      color: theme.palette.text.disabled,
      textDecoration: 'none',
    },
  },

  infoIcon: {
    width: '20px',
    height: '20px',
    color: theme.palette.text.disabled,
    marginLeft: '4px',
  },
})
